import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { REGEX } from 'src/app/constants/regex';
import { CorporateService, HttpService, UtilityFlightService } from 'src/app/services';

@Component({
  selector: 'app-flight-management',
  templateUrl: './flight-management.component.html',
  styleUrls: ['./flight-management.component.scss']
})
export class FlightManagementComponent implements OnInit {
  showUserDiv = false;
  userB2BType: any;
  countryList: any;
  userManagement: FormGroup;
  type = new FormControl('createUser');
  firstName = new FormControl('', Validators.required);
  lastName = new FormControl('', Validators.required);
  mobile = new FormControl('', Validators.required);
  userType = new FormControl('', Validators.required);
  countryCode = new FormControl('', Validators.required);
  emailAddress = new FormControl('', [Validators.required, Validators.pattern(REGEX.EMAIL)]);
  listItem: any = [];
  columns = [
    { colKey: 'firstName', colName: 'First Name' },
    { colKey: 'lastName', colName: 'Last Name' },
    { colKey: 'email', colName: 'Email' },
    { colKey: 'mobile', colName: 'Mobile' },
    { colKey: 'user_type_name', colName: 'User Type' },
    { colKey: 'action', colName: 'Action', actions: ['edit'] }
  ]

  constructor(public COPT: CorporateService, private uitlFlight: UtilityFlightService, private http: HttpService) { }

  ngOnInit(): void {
    this.uitlFlight.fetchCountryCodeList().subscribe((data: any) => {
      this.countryList = [
        ...data.filter(c => c.code === "IN"),
        ...data.filter(c => c.code !== "IN")
      ];
    });

    this.COPT.isCorporateBalanceUser().subscribe(res => {
      const dataInfo = res?.data ?? res;
      this.userB2BType = dataInfo?.userB2BType
        ? Object.entries(dataInfo.userB2BType)
            .map(([key, value]) => ({ key, value }))
        : [];
      this.getAgentList();
    });
    this.flightManagement();
  }

  getAgentList() {
    this.http.flightget('users/getAgentList').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.listItem = this.listItem.map(user => {
          const nameParts = user.name?.trim().split(/\s+/) || [];
          const userType = this.userB2BType?.find(
            type => type.key == user.user_type
          );
          return {
            ...user,
            firstName: nameParts[0] || '',
            lastName: nameParts.slice(1).join(' ') || '',
            user_type_name: userType ? userType.value : user.user_type
          };
        });
      }
    });
  }

  flightManagement() {
    this.userManagement = new FormGroup({
      type: new FormControl('createUser'),
      userType: this.userType,
      countryCode: this.countryCode,
      mobile: this.mobile,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.emailAddress,
    });
  }

  submit_management() {
    if (this.userManagement.invalid) return this.userManagement.markAllAsTouched();
    const { firstName, lastName, countryCode, ...rest } = this.userManagement.value;
    const payload = { 
      ...rest,
      name: `${firstName} ${lastName}`.trim(),
      mobile: `${countryCode}-${rest.mobile}`
    };
    this.http.flightsave('users/createAgent', payload).subscribe((res: any) => {
      if(res.statusCode === 200) {
        this.getAgentList();
        this.reset_management();
        this.showUserDiv = false;
      }
    }, err => {});
    console.log(payload, 'payload');
  }

  reset_management() {
    this.userManagement.reset();
  }

  rowAction(event) {
    const { row, action } = event;
    console.log(row, action);
      if(action === 'view') {} 
      else if (action === 'edit') {
        this.showUserDiv = true;
        const mobileParts = row.mobile.split('-');
        this.userManagement.patchValue({
          type: 'editUser',
          userType: row.user_type,
          countryCode: mobileParts[0] || '',
          mobile: mobileParts[1] || '', 
          firstName: row.firstName,
          lastName: row.lastName,
          email: row.email
        });
      }
  }
}